import { render } from "./iPhonePreview.vue?vue&type=template&id=020fb502&scoped=true"
import script from "./iPhonePreview.vue?vue&type=script&lang=js"
export * from "./iPhonePreview.vue?vue&type=script&lang=js"

import "./iPhonePreview.vue?vue&type=style&index=0&id=020fb502&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020fb502"]])

export default __exports__